<template>
    <div id="google-map"></div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        },
        centerMapOnClick: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            markers: []
        };
    },
    mounted() {
        this.initMap();
    },
    methods: {
        initMap() {
            this.map = new google.maps.Map(
                document.getElementById("google-map"),
                {
                    mapTypeControl: !this.isMobile,
                    mapTypeControlOptions: {
                        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                        position: google.maps.ControlPosition.LEFT_BOTTOM
                    }
                }
            );
            this.setupMap(this.mapZoom);
        },
        setupMap(zoom) {
            return new Promise(resolve => {
                this.addMapMarkers();
                this.setMapCenter({
                    latitude: this.centerCoordinates.lat,
                    longitude: this.centerCoordinates.lng
                });
                this.map.setZoom(zoom);
                resolve();
            });
        },
        setMapCenter(center) {
            this.map.setCenter({
                lat: Number(center.latitude),
                lng: Number(center.longitude)
            });
        },
        addMapMarkers() {
            let marker, location;
            this.items.forEach((item, key) => {
                location = {
                    lat: Number(item.latitude),
                    lng: Number(item.longitude)
                };
                marker = new google.maps.Marker({
                    position: location,
                    map: this.map
                });

                this.actionMapMarker(marker, item);

                // item.marker = marker;
                this.markers.push(marker);
            });
        },
        actionMapMarker(marker, item) {
            marker.addListener("click", () => {

                if(this.centerMapOnClick){
                    this.map.setZoom(16);
                    this.map.setCenter(marker.getPosition());
                }

                this.$emit("itemClicked", item);
            });
        }
    },
    computed: {
        mapZoom() {
            if (this.items.length === 1) return 16;
            if (window.innerWidth >= 768) return 8;
            return 7;
        },
        centerCoordinates() {
            if (this.items.length === 1)
                return {
                    lat: this.items[0].latitude,
                    lng: this.items[0].longitude
                };
            return {
                lat: 41.95,
                lng: 1.566979
            };
        },
        isMobile() {
            return window.innerWidth < 768;
        },
    }
};
</script>

<style lang="scss">
.map {
    height: 100vh;
    width: 100%;
}
</style>
